export const getStyle = ({
  bgColor,
  bgColorHover,
  discountColor,
  ctaBgColor,
  ctaBgHoverColor,
  isMobile
}) => {
  return `
    <style>
      .promo-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: ${isMobile ? '300px' : '400px'};
        width: 100%;
        margin: 0 auto 30px auto;
        cursor: pointer;
        height: ${isMobile ? '350px' : '500px'};
      }

      .promo-image {
        width: 100%;
        height: ${isMobile ? '250px' : '400px'};
        object-fit: cover;
        object-position: center;
        border-radius: 8px;
        margin-bottom: 20px;
      }

      .promo-title {
        font-size: 32px;
        font-family: Spectral-ExtraLight, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
        height: 80px;
        display: flex;
        justify-content: center;
        text-align: center;
        line-height: 1.2;
        padding: 0 10px;
        box-sizing: border-box;
      }

      /* Responsive adjustments */
      @media (max-width: 768px) {
        .promo-container {
          max-width: 100%;
        }
        
        .promo-image {
          height: 200px;
        }
        
        .promo-title {
          font-size: 16px;
          line-height: 1.2;
          height: 60px;
        }
      }

    </style>
  `;
};
